<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Overuren totaal</h2>
            </div>
            <div class="box-body no-padding">
                <table class="table table-striped table-hover text-center">
                    <thead>
                        <tr>
                            <th>Jaar</th>
                            <th>Uren volgens contract</th>
                            <th>Vakantieuren volgens contract</th>
                            <th>Vakantieuren + correcties</th>
                            <th>Geregistreerde uren</th>
                            <th>Opgenomen vakantieuren</th>
                            <th>Totaal</th>
                            <th>Verschil</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="totals.length === 0">
                            <td colspan="5">Er zijn geen resultaten beschikbaar</td>
                        </tr>
                        <tr v-for="total in totals">
                            <td>{{ total.year }}</td>
                            <td>{{ total.contracthours }}</td>
                            <td>{{ total.holidayhours }}</td>
                            <td>{{ total.contractholidayhours }}</td>
                            <td>{{ total.timeregistrationhours }}</td>
                            <td>{{ total.holidayhours }}</td>
                            <td>{{ total.timeregistrationhours + total.holidayhours }}</td>
                            <td>{{ (total.timeregistrationhours + total.holidayhours) - total.contracthours }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="overlay" v-if="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Vakantieuren correcties</h2>
                <div class="box-tools">
                    <button
                        type="button"
                        class="btn btn-primary btn-xs"
                        @click="openAddCorrection"
                        v-tooltip="'Correctie regel toevoegen'"
                    ><i class="mdi mdi-plus"></i></button>
                </div>
            </div>
            <div class="box-body no-padding">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th>Jaar</th>
                            <th>Aantal uren</th>
                            <th>Toegevoegd door</th>
                            <th>Toegevoegd op</th>
                            <th>Omschrijving</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="corrections.length === 0">
                            <td colspan="6">Er zijn geen correcties beschikbaar</td>
                        </tr>
                        <tr v-for="correction in corrections">
                            <td>{{ correction.year }}</td>
                            <td>{{ correction.hours }}</td>
                            <td>{{ correction.creator.fullname }}</td>
                            <td>{{ correction.created_at }}</td>
                            <td>{{ correction.description }}</td>
                            <td class="text-right">
                                <delete-button
                                    title="Correctie"
                                    class="btn-sm"
                                    @delete-completed="correctionDeleted(correction)"
                                    :url="correction.paths.delete"
                                    :name="'Correctie van ' + correction.hours + ' uur voor jaar ' + correction.year"
                                    v-tooltip="'Correctie verwijderen'"
                                ></delete-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="overlay" v-if="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <div class="modal fade" id="hrCorrectionModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Correctie toevoegen</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-horizontal">
                            <div class="form-group">
                                <label class="control-label col-sm-3" for="year">Jaar</label>
                                <div class="col-sm-9">
                                    <date-picker
                                        id="year"
                                        type="year"
                                        lang="en"
                                        v-model="form.year"
                                        format="YYYY"
                                    ></date-picker>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-3" for="hours">Aantal uren</label>
                                <div class="col-sm-9">
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="hours"
                                        maxlength="5"
                                        :value="form.hours"
                                        @input="setHours($event)"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-3" for="description">Omschrijving</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" id="description" v-model="form.description" />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-9 col-sm-offset-3">
                                    <button class="btn btn-primary" :disabled="!canSubmit" @click="onSubmit">Opslaan</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';

export default {

    components: {
        DatePicker,
    },

    computed: {

        canSubmit() {
            return this.posting === false &&
                this.form.year !== null && parseInt(moment(this.form.year).format("YYYY")) > 1950 && parseInt(moment(this.form.year).format("YYYY")) < 2100 &&
                this.form.hours !== 0 &&
                this.form.description !== "";
        },

        getPostdata() {
            return {
                year:parseInt(moment(this.form.year).format("YYYY")),
                hours:this.form.hours,
                description:this.form.description,
            };
        },

    },

    data() {
        return {
            corrections:[],
            form: {
                year:"",
                hours:0,
                description:'',
            },
            loading:true,
            posting:false,
            totals: [],
        }
    },

    methods: {

        addToTotals(year, hours) {
            let index = this.getIndex(year);
            if (index === -1) {
                return;
            }
            this.totals[index].contractholidayhours += hours;
        },

        close() {
            $('#hrCorrectionModal').modal('hide');
        },

        correctionDeleted(correction){
            this.removeFromTotals(correction.year, correction.hours);
            this.corrections.splice(this.corrections.findIndex(corr => corr.uuid === correction.uuid), 1);
        },

        getIndex(year) {
            return this.totals.findIndex(total => total.year === year);
        },

        getTotals() {
            axios.get(this.totalsUri)
            .then(resp => {
                this.corrections = resp.data.data.corrections;
                this.totals = resp.data.data.overtime;
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het ophalen van de gegevens"))
            .finally(() => this.loading = false);
        },

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }
            this.posting = true;
            axios.post(this.correctionsUri, this.getPostdata)
            .then(resp => {
                this.corrections.push(resp.data.data.correction);
                this.addToTotals(this.getPostdata.year, this.getPostdata.hours);
                this.$snotify.success("De correctie is toegevoegd");
                this.close();
            })
            .catch(err => this.$snotify.error("Er is een fout opgetreden bij het opslaan van de correctie"))
            .finally(() => this.posting = false);
        },

        openAddCorrection() {
            $('#hrCorrectionModal').modal('show');
        },

        removeFromTotals(year, hours) {
            let index = this.getIndex(year);
            if (index === -1) {
                return;
            }
            this.totals[index].contractholidayhours -= hours;
        },

        setHours(event) {
            // Validate the value
            let value = event.target.value;
            value = value.replace(/,/g, ".");
            // Check if its an empty string
            if (value === "" || isNaN(parseFloat(value))) {
                value = 0;
            }
            this.form.hours = parseFloat(value);
        },

    },

    mounted() {
        this.getTotals();
    },

    name:"HROvertimeTotals",

    props: {
        correctionsUri: { required:true },
        totalsUri: { required:true },
    },

}

</script>
